import React from "react";
import styled from "styled-components";

// components
import ProjectImage from "../components/molecules/ProjectImage";

// images
import genderOne from "../assets/images/projects/genderOne.jpg";
import genderTwo from "../assets/images/projects/genderTwo.jpg";
import genderThree from "../assets/images/projects/genderThree.jpg";

import genderFour from "../assets/images/projects/genderFour.jpg";
import genderFive from "../assets/images/projects/genderFive.jpg";
import genderSix from "../assets/images/projects/genderSix.jpg";

import genderSeven from "../assets/images/projects/genderSeven.jpg";
import genderEight from "../assets/images/projects/genderEight.jpg";
import genderNine from "../assets/images/projects/genderNine.jpg";

// flower
import flowerOne from "../assets/images/projects/flowerOne.jpg";
import flowerTwo from "../assets/images/projects/flowerTwo.jpg";
import flowerThree from "../assets/images/projects/flowerThree.jpg";

import flowerFour from "../assets/images/projects/flowerFour.jpg";
import flowerFive from "../assets/images/projects/flowerFive.jpg";
import flowerSix from "../assets/images/projects/flowerSix.jpg";

import flowerSeven from "../assets/images/projects/flowerSeven.jpg";
import flowerEight from "../assets/images/projects/flowerEight.jpg";
import flowerNine from "../assets/images/projects/flowerNine.jpg";

// style
const StyledProjectsScreen = styled.main`
  min-height: 88vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h1 {
    opacity: 0.2;
    font-size: 3rem;
  }
  .projects {
    h2 {
      font-weight: 400;
      opacity: 0.6;
      font-size: 2rem;
    }
  }

  // tablet
  @media screen and (min-width: 768px) {
    .projects {
      width: 95%;

      .images {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
    }
  }

  // 720 screen
  @media screen and (min-width: 1366px) {
    .projects {
      width: 90%;
      .images {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
      }
    }
  }
`;

const BlogScreen = () => {
  return (
    <StyledProjectsScreen>
      <h1>Projects</h1>
      <div className="projects">
        <h2>Un homme et une femme</h2>
        <div className="images">
          <ProjectImage
            imageOne={genderOne}
            imageTwo={genderTwo}
            imageThree={genderThree}
          />
          <ProjectImage
            imageOne={genderFour}
            imageTwo={genderFive}
            imageThree={genderSix}
          />
          <ProjectImage
            imageOne={genderSeven}
            imageTwo={genderEight}
            imageThree={genderNine}
          />
        </div>
      </div>
      <div className="projects">
        <h2>Fleur sauvage</h2>
        <div className="images">
          <ProjectImage
            imageOne={flowerOne}
            imageTwo={flowerTwo}
            imageThree={flowerThree}
          />
          <ProjectImage
            imageOne={flowerFour}
            imageTwo={flowerFive}
            imageThree={flowerSix}
          />
          <ProjectImage
            imageOne={flowerSeven}
            imageTwo={flowerEight}
            imageThree={flowerNine}
          />
        </div>
      </div>
    </StyledProjectsScreen>
  );
};

export default BlogScreen;
